import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Container, Grid, Link, Typography, useMediaQuery } from '@mui/material';
import AppThemeSwitcher from '../../../components/layout/AppThemeSwitcher';
import { useTheme } from '@mui/styles';

export default function Footer(props: any) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Box
			component="footer"
			sx={{
				backgroundColor: 'background.paper',
				borderTop: 1,
				borderTopColor: 'divider',
				paddingY: isMobile ? 3 : 1,
			}}
			id="app-footer"
			{...props}
		>
			<Container>
				<Grid
					container
					spacing={isMobile ? 3 : 2}
					alignItems="center"
					direction={isMobile ? 'column-reverse' : 'row'}
				>
					<Grid item sm={4} xs={12}>
						<Typography color="textSecondary" align={isMobile ? 'center' : 'left'}>
							{'Copyright © '}
							{new Date().getFullYear()}
							{' Aptivos LLC. All rights reserved.'}
						</Typography>
					</Grid>
					<Grid item sm={4} xs={12}>
						<Box textAlign="center">
							<AppThemeSwitcher />
						</Box>
					</Grid>
					<Grid item sm={12} xs={12} md={4}>
						<Box
							textAlign="right"
							sx={{
								[theme.breakpoints.down('md')]: {
									display: 'flex',
									flexWrap: 'wrap',
									justifyContent: 'center',
								},
							}}
						>
							<Link
								sx={{
									color: 'text.primary',
									fontSize: 16,

									'&:not(:last-child)': {
										marginRight: 3,
									},
								}}
								component={RouterLink}
								to="/about-us"
							>
								About Us
							</Link>
							<Link
								sx={{
									color: 'text.primary',
									fontSize: 16,

									'&:not(:last-child)': {
										marginRight: 3,
									},
								}}
								component={RouterLink}
								to="/support"
							>
								Support
							</Link>
							<Link
								sx={{
									color: 'text.primary',
									fontSize: 16,

									'&:not(:last-child)': {
										marginRight: 3,
									},
								}}
								component={RouterLink}
								to="/terms-of-service"
							>
								Terms of Service
							</Link>
							<Link
								sx={{
									color: 'text.primary',
									fontSize: 16,

									'&:not(:last-child)': {
										marginRight: 3,
									},
								}}
								component={RouterLink}
								to="/privacy-policy"
							>
								Privacy Policy
							</Link>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
}
